import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CricketIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CricketIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25883 5.39835C4.93962 4.71379 5.23579 3.90007 5.92035 3.58086C6.60491 3.26164 7.41863 3.55781 7.73784 4.24237L10.0389 9.17704H10.7726C11.1113 9.17704 11.4189 9.37467 11.5596 9.68276L15.279 17.8241C15.8233 19.0157 15.3048 20.4233 14.1175 20.977C12.9264 21.5324 11.5104 21.0196 10.9511 19.8304L7.19659 11.8473C7.05066 11.537 7.0579 11.1764 7.21618 10.8722L7.53006 10.269L5.25883 5.39835ZM6.23731 4.26059C5.92816 4.40475 5.7944 4.77223 5.93857 5.08139L7.5 8.5L8.6339 8.00872L7.05811 4.55933C6.91395 4.25018 6.54647 4.11643 6.23731 4.26059ZM8.95098 8.6887L7.81708 9.17999L8.197 9.92462L9.31655 9.40257L8.95098 8.6887ZM8.08187 10.8333L7.8815 11.2184C7.83123 11.315 7.82893 11.4296 7.87528 11.5281L11.6298 19.5112C12.0132 20.3265 12.9839 20.678 13.8005 20.2972C14.6145 19.9177 14.97 18.9527 14.5968 18.1358L10.8774 9.99441C10.8587 9.95337 10.8177 9.92704 10.7726 9.92704H10.1405L8.08187 10.8333Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1965 11.4573C14.1598 12.2331 13.9483 13.7024 14.7241 14.7391C15.4999 15.7758 16.9692 15.9873 18.0059 15.2115C19.0426 14.4357 19.2541 12.9664 18.4783 11.9297C17.7025 10.893 16.2332 10.6815 15.1965 11.4573ZM17.7085 12.1867C16.9768 13.2254 15.8523 13.8281 15.186 14.0696C14.8314 13.3891 15.0115 12.5325 15.6459 12.0578C16.2813 11.5823 17.1557 11.6521 17.7085 12.1867ZM15.7205 14.6641C16.4311 14.361 17.3974 13.7856 18.1286 12.8751C18.3159 13.4981 18.1077 14.1986 17.5566 14.6111C17.0023 15.0258 16.2663 15.0257 15.7205 14.6641Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25883 5.39835C4.93962 4.71379 5.23579 3.90007 5.92035 3.58086C6.60491 3.26164 7.41863 3.55781 7.73784 4.24237L10.0389 9.17704H10.7726C11.1113 9.17704 11.4189 9.37467 11.5596 9.68276L15.279 17.8241C15.8233 19.0157 15.3048 20.4233 14.1175 20.977C12.9264 21.5324 11.5104 21.0196 10.9511 19.8304L7.19659 11.8473C7.05066 11.537 7.0579 11.1764 7.21618 10.8722L7.53006 10.269L5.25883 5.39835ZM6.23731 4.26059C5.92816 4.40475 5.7944 4.77223 5.93857 5.08139L7.5 8.5L8.6339 8.00872L7.05811 4.55933C6.91395 4.25018 6.54647 4.11643 6.23731 4.26059ZM8.95098 8.6887L7.81708 9.17999L8.197 9.92462L9.31655 9.40257L8.95098 8.6887ZM8.08187 10.8333L7.8815 11.2184C7.83123 11.315 7.82893 11.4296 7.87528 11.5281L11.6298 19.5112C12.0132 20.3265 12.9839 20.678 13.8005 20.2972C14.6145 19.9177 14.97 18.9527 14.5968 18.1358L10.8774 9.99441C10.8587 9.95337 10.8177 9.92704 10.7726 9.92704H10.1405L8.08187 10.8333Z"
        stroke="#696969"
        strokeWidth="0.25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1965 11.4573C14.1598 12.2331 13.9483 13.7024 14.7241 14.7391C15.4999 15.7758 16.9692 15.9873 18.0059 15.2115C19.0426 14.4357 19.2541 12.9664 18.4783 11.9297C17.7025 10.893 16.2332 10.6815 15.1965 11.4573ZM17.7085 12.1867C16.9768 13.2254 15.8523 13.8281 15.186 14.0696C14.8314 13.3891 15.0115 12.5325 15.6459 12.0578C16.2813 11.5823 17.1557 11.6521 17.7085 12.1867ZM15.7205 14.6641C16.4311 14.361 17.3974 13.7856 18.1286 12.8751C18.3159 13.4981 18.1077 14.1986 17.5566 14.6111C17.0023 15.0258 16.2663 15.0257 15.7205 14.6641Z"
        stroke="#696969"
        strokeWidth="0.25"
      />
    </svg>
  );
};

export default CricketIcon;
